//
import SlSellerSaleCommissionModel from '@/models/Sale/SlSellerSaleCommission'

/**
 * This class describes a sl customer.
 * @class SlSellerSaleCommission (name)
 */
export default class SlSellerSaleCommission extends SlSellerSaleCommissionModel {

	/**
	 * Returns a list representation of the object.
	 * @return {Object} List representation of the object.
	 */
	static toList() {
		return this
	}
}